import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { loadIpmaMaMembershipStatisticsCreator } from 'store/actionsCreators';
import MembershipStatisticsTable from './MembershipStatisticsTable';

/** Welcome letters and membership badges issued, per Member Association. */
const MaMembershipStatistics = ({ items, loading, loadStatistics }) => {
  const { t } = useTranslation();

  useEffect(() => {
    loadStatistics();
  }, []);

  return (
    <MembershipStatisticsTable
      items={items}
      loading={loading}
      organisationHeading={t('page.ipma.membershipStatistics.memberAssociation')}
      showHonorary
    />
  );
};

MaMembershipStatistics.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loading: PropTypes.bool.isRequired,
  loadStatistics: PropTypes.func.isRequired,
};

const mapStateToProps = ({ ipma, loading }) => ({
  items: ipma.people.maMembershipStatistics.items,
  loading: !!loading.filter((item) => item.type === 'IPMA').length,
});

const mapDispatchToProps = (dispatch) => ({
  loadStatistics: () => dispatch(loadIpmaMaMembershipStatisticsCreator()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MaMembershipStatistics);
